export enum MaterialColor {
    red = '#FF0000',
    purple = '#6F2DBD',
    blue = '#0066E6',
    orange = '#FF9500',
    green = '#7CB518',
    cian = '#14B8B1',
    brown = '#7D4E24',
    magenta = '#C44994',
    skyBlue = '#36A9E1',
    gray = '#616160',
    oldPink = '#BB757D',
}